import * as analytics from "./analytics";
import * as billing from "./billing";
import * as device from "./devices";
import * as user from "./users";

export const AnalyticsAPI = new analytics.AnalyticsAPI();
export const BillingAPI = new billing.BillingAPI();
export const DevicesAPI = new device.DevicesAPI();
export const UserAPI = new user.UserAPI();